import { useMemo } from 'react';

import { PageModule, PageModuleType } from '@/types/module.types';
import { Speaker } from '@/types/speakers.types';
import { TReactSelectOption } from '@ui/select/react-select/custom-react-select.types';
import { Session } from '@/types/session.types';

const useDefaultSpeakers = ({ session }: { session: Session | null }) => {
  return useMemo(() => {
    if (!session) return [];
    const speakers = (session?.modules || [])
      .filter(
        (module: PageModule) =>
          module.type === PageModuleType.speakers && module.is_on && module.content_modules?.length
      )
      .flatMap((module) => module.modules ?? []) as Speaker[];

    return speakers
      .map((s) => {
        if (!s) return null;
        return {
          label: `${s.first_name} ${s.last_name} ${s?.email || ''}`.trim(),
          value: s.speaker,
          meta: s,
        };
      })
      .filter(Boolean) as TReactSelectOption<string, number, Speaker>[];
  }, [session]);
};

export default useDefaultSpeakers;
